export default __webpack_public_path__ + "static/media/column.db39951f.svg";